import http from '../http';
export const login = (authHostname) => (body, params) => http({ url: authHostname + 'frontend/login/', body, query: params });
export const logout = (authHostname, revokeTokenParams) => http({
    url: authHostname + 'revoke_token/',
    body: `client_id=${revokeTokenParams.client_id}&token=${revokeTokenParams.access_token}`,
    method: 'POST',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});
export const refreshToken = (authHostname, authId, refreshToken) => {
    const bodyRefreshToken = refreshToken ? `&refresh_token=${refreshToken}` : '';
    return http({
        url: authHostname + 'token/',
        body: `grant_type=refresh_token&client_id=${authId}${bodyRefreshToken}`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};
export const obtainToken = (authHostname) => (params) => {
    const body = new URLSearchParams();
    Object.keys(params).forEach((key) => body.append(key, params[key]));
    return http({
        url: authHostname + 'token/',
        body: body.toString(),
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};
//# sourceMappingURL=index.js.map